var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chat-button"},[_c('button',{style:(_vm.style),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default",[_vm._v("发送")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }